export var IP =
         process.env.NODE_ENV === "development"
           ? "http://127.0.0.1:3038" //本地代理
           : "https://fair-wangsheng-api.bboycc.cn";